<template>
  <div>
    <div class="listGroup">
      <div class="listGroup__item"
        v-for="counselor in counselors"
        v-bind:key="counselor.name"
      >
        <a
          class="media"
          v-bind:href="orderLink(counselor.items_id)"
        >
          <div class="media__image">
            <img :src="counselor.image_url" :alt="counselor.name" width="72" height="72">
          </div>
          <div class="media__content">
            <div v-show="counselor.max_order - counselor.order_count > 0">
              <span class="badge--brand-2">受付中！</span>
              <strong class="tx-brand-2">残り{{ counselor.max_order - counselor.order_count }}名</strong>
            </div>
            <h4>{{ counselor.name }}</h4>
            <p class="tx-sub" v-html="counselor.profile"></p>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// mutation types
import * as type from '@/utvStore/store/mutation-types'

export default {
  name: 'counselors-list',
  computed: {
    ...mapState({
      counselors: state => state.counselors.collection
    })
  },
  beforeCreate() {
    this.$store.dispatch(type.GET_COUNSELORS)
  },
  methods: {
    orderLink(itemsId) {
      return `/movie/0000${itemsId}`
    }
  }
}</script>

<style scoped lang="scss">

.listGroup {
  &__item {
    border-bottom: 1px solid #EEE;
    padding: 8px 0;
  }
}

.media {
  color: #4F4F4F;
  &:hover {
    text-decoration: none;
  }
  &__image {
    margin-right: 16px;
    > img {
      width: 72px;
      height: 72px;
      object-fit: cover;
      border-radius: 36px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/CounselorsList.vue